var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonInYellowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3333 23.6667C25.3333 21.8986 26.0357 20.2029 27.286 18.9526C28.5362 17.7024 30.2319 17 32 17C33.7681 17 35.4638 17.7024 36.714 18.9526C37.9643 20.2029 38.6667 21.8986 38.6667 23.6667C38.6667 25.4348 37.9643 27.1305 36.714 28.3807C35.4638 29.631 33.7681 30.3333 32 30.3333C30.2319 30.3333 28.5362 29.631 27.286 28.3807C26.0357 27.1305 25.3333 25.4348 25.3333 23.6667ZM25.3333 33.6667C23.1232 33.6667 21.0036 34.5446 19.4408 36.1074C17.878 37.6702 17 39.7899 17 42C17 43.3261 17.5268 44.5979 18.4645 45.5355C19.4021 46.4732 20.6739 47 22 47H42C43.3261 47 44.5979 46.4732 45.5355 45.5355C46.4732 44.5979 47 43.3261 47 42C47 39.7899 46.122 37.6702 44.5592 36.1074C42.9964 34.5446 40.8768 33.6667 38.6667 33.6667H25.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonInYellowCircle);
export default __webpack_public_path__ + "static/media/person-in-yellow-circle.a7031efad3579675baca65e0b1f42373.svg";
export { ForwardRef as ReactComponent };